export const ALL_OPTIONS = '__ALL_OPTIONS__';
export const EMPTY_OPTION = '__EMPTY_OPTION__';
